module.exports = __webpack_public_path__ + "static/@0,5xcomment-4e5d9c713fae0495a65638e9d7bc31e1.png";